import Vue from 'vue'
import Vuex from 'vuex'

import qs from 'qs';
Vue.use(Vuex)

export default ({
  namespaced: true,
  state: {
    validationCycle: {
      name: '',
      startDate: new Date().toLocaleDateString('en-US'),
      endDate: new Date().toLocaleDateString('en-US'),
      rps: []
    },
    validationCycles: [],
    measurementYears: []
  },
  getters: {
    getValidationCycle: (state) => {
      return state.validationCycle
    },
    getValidationCycles: (state) => {
      return state.validationCycles
    },
    getMeasurementYears: (state) => {
      return state.measurementYears
    }
  },
  actions: {
    loadCurrentValidationCycle(context) {
      return Vue.axios.get('/api/validationCycle/current').then((res) => {
        return context.commit('setValidationCycle', res.data)
      })
    },
    async getQAReport(context) {
      return await Vue.axios.get('/api/qa/export', {
        params: {
          validationCycleId: context.state.validationCycle.validationCycleId
        }
      }).then(res => {
        let csv = '';
        res.data.forEach(row => {
          csv += Object.values(row).join(',')
          csv += "\n";
        })
        return csv
      })
    },
    async getStatistics(context) {
      return await Vue.axios.get('/api/validationCycle/statistics', {
        params: {
          validationCycleId: context.state.validationCycle.validationCycleId
        }
      }).then(res => {
        let csv = '';
        res.data.forEach(row => {
          csv += Object.values(row).join(',')
          csv += "\n";
        })
        return csv
      })
    },
    async saveValidationCycle(context, validationCycle) {
      await Vue.axios.post('/api/validationCycles/save', qs.stringify(validationCycle)).then((res) => {
        validationCycle = JSON.parse(res.data.object)
        validationCycle.startDate = new Date(validationCycle.startDate.timestamp * 1000)
        validationCycle.endDate = new Date(validationCycle.endDate.timestamp * 1000)
        context.dispatch('getValidationCycles')
        context.commit('setValidationCycle', validationCycle)
      })
    },
    async getValidationCycles(context, data) {
      await Vue.axios.get('/api/validationCycles/list', data).then((res) => {
        context.commit('loadValidationCycles', JSON.parse(res.data.validationCycles))
      })
    },
    async loadMeasurementYears(context) {
      await Vue.axios.get('/api/validationCycles/measurementYears').then((res) => {
        context.commit('saveMeasurementYears', res.data)
      })
    },
    clearValidationCycle: (context) => {
      context.commit('clearValidationCycle')
    },
    loadValidationCycle(context, validationCycleId) {
      return Vue.axios.get('/api/validationCycle/load', {
        params: {
          id: validationCycleId
        }
      }).then((res) => {
        let validationCycle = JSON.parse(res.data.validationCycle)
        validationCycle.startDate = (validationCycle.startDate !== null ? new Date(validationCycle.startDate.timestamp * 1000) : new Date().toLocaleDateString('en-US'))
        validationCycle.endDate = (validationCycle.endDate !== null ? new Date(validationCycle.endDate.timestamp * 1000) : new Date().toLocaleDateString('en-US'))
        context.commit('setValidationCycle', validationCycle)
      })
    },
    addRP(context, rp) {
      let formData = new FormData
      formData.append('validationCycle', context.state.validationCycle.id)
      formData.append('rp', rp.id)
      return Vue.axios.post('/api/validationCycles/addRP', formData).then((res) => {
        context.dispatch('petra/rps/loadRPs', context.state.validationCycle.id, {
          root: true
        })
        return res.result
      })
    }
  },
  mutations: {
    setValidationCycle(state, validationCycle) {
      state.validationCycle = validationCycle
    },
    clearValidationCycle(state) {
      state.validationCycle = {
        name: '',
        startDate: new Date().toLocaleDateString('en-US'),
        endDate: new Date().toLocaleDateString('en-US')
      }
    },
    loadValidationCycles(state, validationCycles) {
      state.validationCycles = validationCycles
    },
    saveMeasurementYears(state, measurementYears) {
      state.measurementYears = measurementYears
    }
  }
})